module.exports = __webpack_public_path__ + "static/media/guide2.fb97cd1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/guide2.png
// module id = 390
// module chunks = 0